var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email_notification",
    "data-name": "email notification",
    transform: "translate(3028 -5635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_184",
    "data-name": "Rectangle 184",
    transform: "translate(-3028 5635)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 93,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 92,
    height: 92,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail",
    transform: "translate(-3020 5584.786)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_190",
    "data-name": "Rectangle 190",
    width: 63.13,
    height: 44.032,
    transform: "translate(0.388 80.632) rotate(0.504)",
    fill: "#cfdce5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_654",
    "data-name": "Group 654",
    transform: "translate(0.279 80.632)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M1.834,162.3l31.34,14.8,31.782-14.244.109-12.443-63.121-.555Z",
    transform: "translate(-1.834 -149.859)",
    fill: "#415e72"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_655",
    "data-name": "Group 655",
    transform: "translate(0.002 93.075)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M19.1,240.55,4.418,263.293l-4.407-.039.277-31.587Z",
    transform: "translate(-0.011 -231.668)",
    fill: "#415e72"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_656",
    "data-name": "Group 656",
    transform: "translate(44.438 93.629)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M292.174,243.865l14.278,23,4.407.039.277-31.587Z",
    transform: "translate(-292.174 -235.314)",
    fill: "#415e72"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_68",
    "data-name": "Ellipse 68",
    cx: 14.29,
    cy: 14.298,
    rx: 14.29,
    ry: 14.298,
    transform: "translate(78 68.466) rotate(90.504)",
    fill: "#e04f5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M390.618,128.695a6.146,6.146,0,0,0,2.845.8c1.809.017,2.549-1,2.543-1.982.013-1.481-1.368-2.129-2.812-2.143l-1.1-.01.016-1.732,1.06.01c1.1.01,2.489-.484,2.5-1.732.007-.848-.621-1.563-1.988-1.574a5.036,5.036,0,0,0-2.568.764l-.524-1.717a6.777,6.777,0,0,1,3.609-.932c2.581.024,3.9,1.459,3.881,3.1a3.053,3.053,0,0,1-2.337,2.906v.038a3.163,3.163,0,0,1,2.727,3.148c-.019,2.117-1.8,3.774-4.906,3.754a6.833,6.833,0,0,1-3.5-.9Z",
    transform: "translate(-330.739 -42.587)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.a64df50b65923c065ea590d840ebb289.svg";
export { ForwardRef as ReactComponent };